export const AnimalId: string = 'Animal ID';
